import { defaultLanguage } from '../../translations/constant'
import { SET_LANGUAGE } from './actionsTypes'

const initialState = {
  selectedLanguage: !!localStorage.getItem('lang')
    ? localStorage.getItem('lang')
    : defaultLanguage,
}

const Language = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_LANGUAGE:
      return {
        ...state,
        selectedLanguage: payload,
      }
    default:
      return state
  }
}

export default Language
